// Webpack Imports
import * as bootstrap from 'bootstrap';

const options = {
	keyboard: true,
	size: 'fullscreen'
};


(function () {
	'use strict';

	// Focus input if Searchform is empty
	// [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
	// 	el.addEventListener('submit', function (e) {
	// 		var search = el.querySelector('input');
	// 		if (search.value.length < 1) {
	// 			e.preventDefault();
	// 			search.focus();
	// 		}
	// 	});
	// });

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	// var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	// var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
	// 	return new bootstrap.Popover(popoverTriggerEl, {
	// 		trigger: 'focus',
	// 	});
	// });



	jQuery(document).ready(function ($) {
		const sections = $('.scroll-section');
		let currentSection = 0;

		function scrollToSection(sectionIndex) {
			const top = sections.eq(sectionIndex).offset().top;

			$('html, body').animate({
				scrollTop: top
			}, 400, 'easeInOutQuart');

			currentSection = sectionIndex;
		}

		function handleMouseWheel(e) {
			e.preventDefault();

			const newSection = currentSection + (e.originalEvent.deltaY > 0 ? 1 : -1);

			if (newSection > 0 && newSection < sections.length) {
				scrollToSection(newSection);
			}
		}

		$(window).on('wheel', handleMouseWheel);
		scrollToSection(currentSection);
		

		const solutions_templates = [
			'page-template-digital-demand-generation',
			'page-template-worldwide-cx-outsourcing',
			'page-template-ai-powered-contact-center',
			'page-template-customer-experience-management',
			'page-template-staff-augmentation',
		];

		if (solutions_templates.some(template => $('body').hasClass(template))) {
			$('body').addClass('sub-pages-solutions');
		}

		const industry_templates = [
			'page-template-automobile',
			'page-template-retail-and-ecommerce',
			'page-template-high-tech',
			'page-template-energy-resources-and-utilities',
			'page-template-education',
			'page-template-banking-and-financial-services',
			'page-template-healthcare',
			'page-template-consumer-goods-and-distribution'
		];

		if (industry_templates.some(template => $('body').hasClass(template))) {
			$('body').addClass('sub-pages-industries');
		}

		$('#header .mega-menu-item a[href^="#"]').on('click', function (event) {
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1000);
					return false;
				}
			}
		});

		$('#header').on('click', '.navbar-toggler', function () {
			$('#navbar').toggleClass('collapse');
		});

	});

})();


